import { BillingStore } from "@/Billing/Stores/BillingStore";
import { BillingInbox } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";

class BillingTabHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Billing.SwitchTo_TransactionsInbox, this.switchTo_TransactionsInbox);
        this.RegisterOperation(LocalOperations.Billing.SwitchTo_SalesInbox, this.switchTo_SalesInbox);
        this.RegisterOperation(LocalOperations.Billing.SwitchTo_PayableInbox, this.switchToPayableInbox);
        this.RegisterOperation(LocalOperations.Billing.BillingClaimStatusInbox, this.switchToBillingClaimStatusInbox);
    }

    private switchTo_TransactionsInbox(request: LocalEvent, store: BillingStore): void {
        store.Model = store.Model.set("CurrentInbox", BillingInbox.Transactions);
        store.BillingAction.LoadTransactionsData(store.TransactionsInboxModel);
    }

    private switchTo_SalesInbox(request: LocalEvent, store: BillingStore): void {
        store.Model = store.Model.set("CurrentInbox", BillingInbox.Sales);

        store.loadSalesProviderUICache();
        store.loadSalesBilledByClinicianUICache();
        store.SalesInboxModel = store.SalesInboxModel.set("PaymentMethod", store.initializeBillingPaymentMethod(CheckboxTarget.Myle_Billing_Sales_PaymentMethod));
        store.SalesInboxModel = store.SalesInboxModel.set("Status", store.initializeBillingStatus(CheckboxTarget.Myle_Billing_Sales_Status));
        store.SalesInboxModel = store.SalesInboxModel.set("Validity", store.initializeBillingValidity(CheckboxTarget.Myle_Billing_Settings_Validity));

        store.BillingAction.LoadSalesData(store.SalesInboxModel);
    }

    private switchToPayableInbox(request: LocalEvent, store: BillingStore): void {
        store.Model = store.Model.set("CurrentInbox", BillingInbox.Payable);
    }

    private switchToBillingClaimStatusInbox(request: LocalEvent, store: BillingStore): void {
        store.Model = store.Model.set("CurrentInbox", BillingInbox.BillingClaimStatus);
    }
}

export { BillingTabHandler };
